module.exports = __webpack_public_path__ + "static/media/whistle.918ff540.svg";